export default from './BuyerCard';



// WEBPACK FOOTER //
// ./src/components/LoanOfficerMessages/components/MobileMessages/components/ChatPage/components/BuyerCard/index.js